import styles from "./EditPortfolio.module.scss";

function EditPortfolio() {
  return <div className={styles.maincontainer}>Edit Portfolio</div>;
}
export default EditPortfolio;
